export default __webpack_public_path__ + "static/media/informe-ancine-min.bc9ad9b8.png";